module.exports = __webpack_public_path__ + "img/search.ef2b87fc.svg";